export default __webpack_public_path__ + "static/char-s-04-jp-782aaed556387ddf90bd68cd115f4465.png";